<template>
  <div
    v-loading="loading"
    element-loading-text="正在登陆"
    element-loading-spinner="el-icon-loading"
  ></div>
</template>

<script>
import { loginstatic, weixinstatic } from "apiurl/login";
export default {
  data() {
    return {
      loading: true,
      infoObj: {}
    };
  },
  created() {
    this.infoObj = {
      code: this.$route.query.code,
      state: this.$route.query.state
    };
    if (this.$route.path == "/loginLoading/qq") {
      loginstatic(this.infoObj).then(
        res => {
          if (res.success) {
            this.$store.dispatch("saveInfo", res.data.userVO);
            this.$router.replace(res.data.backUrl);
          } else {
            if (res.code == 20001) {
              this.$router.replace("/");
            }
          }
        },
        () => {}
      );
    } else {
      weixinstatic(this.infoObj)
        .then(
          res => {
            if (res.success) {
              this.$store.dispatch("saveInfo", res.data.userVO);
              this.$router.replace(res.data.backUrl);
            } else {
              if (res.code == 20001) {
                this.$router.replace("/");
              }
            }
          },
          () => {}
        )
        .catch(() => {});
    }
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = false; // C 跳转到 A 时让 A 不缓存，即刷新
    next();
  }
};
</script>

<style lang="stylus" scoped>
div
    width 100vw
    height 100vh
</style>
